export const VERSION = "2.6.6";